import React, { useCallback, useEffect, useState } from 'react';
import styled, { css, keyframes } from 'styled-components';
import Gallery, { RenderImageProps, PhotoProps } from 'react-photo-gallery';

import { Modal, ModalBody } from 'reactstrap';
import ImageItem from './ImageItem';
import { media } from '../../../common/Layout';
import { photosType } from '../../tabImage/ImageList';

interface styleType {
  cusWidth?: boolean;
}

const ImageListComponent = styled.div`
  position: relative;
  width: 90%;
  margin-top: 15px;

  ${(props: styleType) => {
    if (props.cusWidth) {
      return css`
        width: 100%;
      `;
    }
    return css``;
  }}

  .react-photo-gallery--gallery {
    /* Mobile Device */
    img {
      border-radius: 6px;
    }

    ${media.desktop`
      border-radius: 6px;
    `};
  }
`;

type ImageListProps = {
  photoData: {
    id: string;
    url: string;
    src: string;
    width: number;
    height: number;
    targetId?: number;
    alt?: string | undefined;
    title?: string;
    desc?: string;
    source?: string;
  }[];
};
const ImageList = ({ photoData }: ImageListProps) => {
  const [cusWidth, setCusWidth] = useState(false);
  const [modal, setModal] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setCusWidth(true);
    }, 1000);
  }, []);

  const toggleModal = () => setModal(!modal);

  const imageRenderer = useCallback(
    ({
      left,
      top,
      photo,
      onClick,
      direction,
      margin,
      index,
    }: RenderImageProps) => {
      const tempPhoto: {
        id?: string;
        url?: string;
        src: string;
        width: number;
        height: number;
        targetId?: number;
        alt?: string | undefined;
        title?: string;
        desc?: string;
        source?: string;
      } = photo;

      return (
        <ImageItem
          margin={margin}
          index={index}
          photo={tempPhoto}
          left={left}
          top={top}
          onClick={onClick}
          direction={direction}
          toggleModal={toggleModal}
          key={`${tempPhoto.id}${index}`}
        />
      );
    },
    []
  );

  return (
    <ImageListComponent cusWidth={cusWidth}>
      <Gallery
        photos={photoData}
        renderImage={imageRenderer}
        targetRowHeight={200}
        margin={3}
      />
      <Modal isOpen={modal} toggle={toggleModal}>
        <ModalBody>검색 결과는 준비중입니다.</ModalBody>
      </Modal>
    </ImageListComponent>
  );
};

export default ImageList;
